import React from 'react';
import '../.././components/css/popupstyle.css';
import DeleteIcon from '../.././components/css/dark/img/delete.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';
import $ from 'jquery';
import { userService } from '../../_services';
import { debuglog } from 'util';

class OverridePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            UserDataList: [],
            SearchDispay: [],
            SearchSubDispay: [],
            error: '',
            loading: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            toggleConfirmationPopup: false,
            deleteIndex: 0,
            IsUserAvail: false,
            disNameError: '',
            disEmailError: '',
            disPhoneError: '',
            disCommissionError: '',
            isusersearched: '',
            isEdit: false,
            WhAdvanceSetting: [],
            advanceSetting: false,
            newUser: this.props.chkUser,
            IsBroker: false
        };
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        $('.btn.save-btn').attr('disabled', true);
        this.GetUserList_All(this.state.userdata.paramsname, this.props.SelectedGroupNumber, this.props.userType);
        setTimeout(() => {
            if (this.state.userdata.paramsname.toLowerCase() == 'patient rx discount') {
                $('.btn.save-btn').attr('disabled', true);
            } else {
                $('.btn.save-btn').attr('disabled', false);
            }
        }, 700)
    }

    // confirmation popup
    toggleConfirmationPopup = (e) => {
        let deleteIndex = e.target.parentElement.getAttribute('data-text');
        this.props.closeEditGroupPopup(deleteIndex, 'DeleteReps', '', this.state.UserDataList, '', this.props.SelectedGroupNumber);
        this.props.openResetGroup("Are you sure want to delete this override?", this.props.SelectedGroupNumber);
    }
    // get data from api
    GetUserList_All(WhName, GroupNumber, userType) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ WhName, GroupNumber })
            };
            return fetch(`/api/ws/groupnamedetails`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.fetchAdvanceSetting('', '', '0');
                        if (apidata.length > 0 && apidata[0].distributor_UserId != "0") this.setState({ IsUserAvail: true, isEdit: true });
                        let list = [];
                        apidata[0].subDistributor.forEach(function (a, index) {
                            let l = [];
                            list.push(l);
                        });
                        let APIResponse = JSON.parse(JSON.stringify(apidata));
                        APIResponse.forEach(function (a) {
                            if (a.distributorCommission == "0")
                                a.distributorCommission = "1.75";// parseFloat(a.distributorCommission).toFixed(2).toString();
                        });
                        APIResponse[0].subDistributor.forEach(function (a) {
                            if (a.subDistributorCommission == "0")
                                a.subDistributorCommission = "0.50";// parseFloat(a.distributorCommission).toFixed(2).toString();
                        });
                        let newUserList = APIResponse;
                        if (userType != undefined) {
                            newUserList.forEach(function (a) {
                                a.userType = userType
                            });
                        }
                        this.setState({ UserDataList: newUserList, SearchSubDispay: list });
                        if (this.props.confirmationText == 'yes') {
                            this.Handle_Remove_Subdistributor();
                        } else if (this.props.confirmationText == 'no') {
                            this.Handle_No_Confirmation();
                        }
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    fetchAdvanceSetting(roleName, roleType, id) {
        try {
            let whid = this.state.userdata.wholesaler_Id.toString();
            userService.GetAdvanceSetting(roleName, roleType, whid).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ WhAdvanceSetting: apidata[0].settings[0] });
                        }
                    }
                    catch (error) {
                    }
                }
            );
        }
        catch (error) {
        }
    }
    // handle response
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        // this.setState({ [name]: value });
        let prods = this.state.UserDataList;
        $('.help-block').html('');
        // get current type
        var dataType = $(e.target).attr('data-type');
        if (dataType == 'emailId') {
            prods.forEach(function (a) {
                a.emailId = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disEmailError: '' });
            this.handleBlur();
        }
        if (dataType == 'phoneNumber') {
            prods.forEach(function (a) {
                a.phoneNumber = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disPhoneError: '' });
            this.handleBlur();
        }
        if (dataType == 'distributorCommission') {
            prods.forEach(function (a) {
                a.distributorCommission = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disCommissionError: '' });
            this.handleBlur();
        }
        if (dataType == 'distributorName') {
            prods.forEach(function (a) {
                a.distributorName = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes', disNameError: '' });
        }
        if (dataType == 'userType') {
            prods.forEach(function (a) {
                a.userType = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList, isusersearched: 'yes' });
        }
    }
    subHandleChange = (e) => {
        const { name, value } = e.target;
        // this.setState({ [name]: value });
        let prods = this.state.UserDataList[0];
        $('.help-block').html('');

        // get current type
        var dataType = $(e.target).attr('data-type');
        if (dataType == 'emailId') {
            prods.forEach(function (a) {
                a.emailId = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList });
        }
        if (dataType == 'phoneNumber') {
            prods.forEach(function (a) {
                a.phoneNumber = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList });
        }
        if (dataType == 'distributorCommission') {
            prods.forEach(function (a) {
                a.distributorCommission = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList });
        }
        if (dataType == 'distributorName') {
            prods.forEach(function (a) {
                a.distributorName = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList });
        }
        if (dataType == 'userType') {
            prods.forEach(function (a) {
                a.userType = value;
            });
            let newUserList = prods;
            this.setState({ UserDataList: newUserList });
        }
    }
    handleEdit = (e) => {
        this.state.UserDataList[0].subDistributor.forEach(function (a, index) {
            if (index == e.target.parentElement.getAttribute('data-text')) {
                a.isineditedmode = true;
            }
        });
        let updated = this.state.UserDataList;
        this.setState({ UserDataList: updated });
    }
    handleCancel = (e) => {
        let x = this.state.UserDataList[0].subDistributor;
        let indexedvalue = x[parseInt(e.target.getAttribute('data-text'))];
        if (this.validation(indexedvalue.subDistributorName, indexedvalue.subDistributorEmail, indexedvalue.subDistributorPhone, indexedvalue.subDistributorCommission)) {
            if (indexedvalue.newRow == true) {
                x.splice(parseInt(e.target.getAttribute('data-text')), 1);
                this.state.UserDataList[0].subDistributor = x;
                this.state.SearchSubDispay.splice(parseInt(e.target.getAttribute('data-text')), 1);
            } else {
                this.state.UserDataList[0].subDistributor.forEach(function (a, index) {
                    if (index == parseInt(e.target.getAttribute('data-text'))) {
                        a.isineditedmode = false;
                    }
                });
            }
        }
        else {
            x.splice(parseInt(e.target.getAttribute('data-text')), 1);
            this.state.UserDataList[0].subDistributor = x;
            this.state.SearchSubDispay.splice(parseInt(e.target.getAttribute('data-text')), 1);
        }
        this.setState({ UserDataList: this.state.UserDataList, SearchSubDispay: this.state.SearchSubDispay });
    }
    handleAdd = (e) => {
        // get input field values
        let htmlprefix = $(e.target).parents('.SubDist_GroupBox');
        let subDisId = htmlprefix.find('input[name = "subdisid"]').val();
        let changeDName = htmlprefix.find('input[name = "subdisname"]').val();
        let changeEmail = htmlprefix.find('input[name = "email"]').val();
        let changePhone = htmlprefix.find('input[name = "phone"]').val();
        let changeCommission = htmlprefix.find('input[name = "subcomm"]').val();
        if (this.validation(changeDName, changeEmail, changePhone, changeCommission)) {
            this.SetUpdateSubUser(htmlprefix.find('input[name = "subdisid"]').val(), changeCommission, changeEmail, htmlprefix.find('input[name = "subdisname"]').val(), changePhone);
        }
        else
            this.setState({ error: 'Please check your overrides. All fields are required and commission should be a numeric value e.g. 0.5 or 1.5' });
    }
    validation(changeDName, changeEmail, changePhone, changeCommission) {
        if (!userService.Check_Null_Empty(changeCommission) && !userService.Check_Null_Empty(changeEmail) && !userService.Check_Null_Empty(changeDName) && userService.ValidateEmail(changeEmail) && userService.validateCurrency(changeCommission))
            return true;
        else
            return false;
    }
    SetUpdateSubUser(Id, Comm, Email, Name, Phone) {
        this.state.UserDataList[0].subDistributor.forEach(function (a) {
            if (a.subDisId == Id) {
                a.subDisId = Id;
                a.subDistributorCommission = Comm;
                a.subDistributorEmail = Email;
                a.subDistributorName = Name;
                a.subDistributorPhone = Phone;
                a.isineditedmode = false;
                a.newRow = false;
            }
        });
        let newSubDistributor = this.state.UserDataList;
        this.setState({ UserDataList: newSubDistributor, error: '' });
    }
    addNewSubdistributor = () => {
        this.handleBlur();
        let randomId = Math.floor(10000 + Math.random() * 90000);
        let oldUserList = this.state.UserDataList;
        oldUserList[0].subDistributor.push({
            subDisId: randomId,
            subDistributorCommission: '0.50',
            subDistributorEmail: '',
            subDistributorName: '',
            subDistributorPhone: '',
            isineditedmode: true,
            newRow: true
        });
        let list = [];
        let newIndex = oldUserList[0].subDistributor.length - 1;
        this.state.SearchSubDispay = list;
        this.setState({ UserDataList: oldUserList, SearchSubDispay: this.state.SearchSubDispay });
        setTimeout(function () {
            $('input[textindex=' + newIndex + ']').focus();
        }, 50)
    }
    HandleSearchSubKeyUp = e => {
        $('.SubDist_GroupBox').removeClass('active');
        let currentInput = e.target;
        $(currentInput).parents('.SubDist_GroupBox').addClass('active');
        if ($(currentInput).val().length > 0) {
            setTimeout(function () {
                $('#scroll-on').scrollTop(200);
            }, 500);
            this.Get_Searched_Sub_Distributor_Logs(this.props.SelectedGroupNumber, $(currentInput).val(), this.state.userdata.wholesaler_Id.toString(), 'Name', currentInput.getAttribute('textindex'));
        }
        else {
            let list = [];
            this.setState({ SearchSubDispay: list });
        }
    }
    Get_Searched_Sub_Distributor_Logs(GroupNumber, UserName, WhName, SearchType, typeIndex) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ GroupNumber, UserName, WhName, SearchType })
            };
            return fetch(`api/ws/Search_SubDistributor`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        let list = [];
                        apidata.forEach(function (a, index) {
                            let myJson = {
                                index: index,
                                userComm: a.userComm,
                                userEmail: a.userEmail,
                                userName: a.userName,
                                userPhone: a.userPhone,
                                userType: a.userType
                            }
                            list.push(myJson);
                        });
                        this.state.SearchSubDispay[typeIndex] = list;
                        this.setState({ SearchSubDispay: this.state.SearchSubDispay });
                    }
                    catch (error) {

                    }
                });
        }
        catch (error) {
        }
    }
    SubSearchItemClick = e => {
        try {
            let data = this.state.SearchSubDispay[e.target.getAttribute('data-index')][e.target.getAttribute('data-option')];
            this.state.UserDataList[0].subDistributor[e.target.getAttribute('data-index')].subDistributorPhone = data.userPhone;
            this.state.UserDataList[0].subDistributor[e.target.getAttribute('data-index')].subDistributorEmail = data.userEmail;
            this.state.UserDataList[0].subDistributor[e.target.getAttribute('data-index')].subDistributorName = data.userName;

            $(e.target).parents('.SubDist_GroupBox').find('input[name = "subdisname"]').val(data.userName);
            $(e.target).parents('.SubDist_GroupBox').find('input[name = "phone"]').val(data.userPhone);
            $(e.target).parents('.SubDist_GroupBox').find('input[name = "email"]').val(data.userEmail);
            $(e.target).parents('.SubDist_GroupBox').find('input[name = "subcomm"]').focus();

            let l = []; this.state.SearchSubDispay[e.target.getAttribute('data-index')] = l;

            this.setState({ UserDataList: this.state.UserDataList, SearchSubDispay: this.state.SearchSubDispay });
        }
        catch (error) {
        }
    }
    handleBlur = e => {
        if (this.state.SearchDispay.length > 0) {
            this.setState({ IsBroker: false, SearchDispay: '' });
        }
    }
    HandleSearchKeyUp = e => {
        if (!this.state.IsUserAvail) {
            if ($('#myDistInput').val().length >= 0) {
                this.Get_Searched_Distributor_Logs($('#myDistInput').val(), this.state.userdata.wholesaler_Id.toString(), 'Name');
            }
            else {
                this.setState({ SearchDispay: null, IsBroker: false, UserDataList: [] });
            }
        }
    }
    Get_Searched_Distributor_Logs(UserName, WhName, SearchType) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserName, WhName, SearchType })
            };
            return fetch(`/api/ws/Search_Distributor`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (UserName.length > 0) {
                            this.setState({ SearchDispay: apidata, IsBroker: apidata[0].isBroker });
                        }
                        else {
                            let temp = this.state.UserDataList;
                            temp[0].emailId = '';
                            if (this.state.WhAdvanceSetting.isBroker == false) {
                                this.setState({ IsBroker: false, UserDataList: temp, SearchDispay: '' });
                            }
                            else {
                                this.setState({ IsBroker: true, UserDataList: temp, SearchDispay: '' });
                            }
                        }
                    }
                    catch (error) {

                    }
                });
        }
        catch (error) {
        }
    }
    HandleSearchItemClick = e => {
        try {
            let UserName = $(e.target).attr('data-text');
            let WhName = this.state.userdata.wholesaler_Id.toString();
            let SearchType = 'Details';
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserName, WhName, SearchType })
            };
            return fetch(`/api/ws/Search_Distributor`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            let temp = this.state.UserDataList;
                            if (!this.state.IsUserAvail)
                                temp[0].emailId = apidata[0].userEmail;
                            temp[0].distributorName = apidata[0].userName;
                            // temp[0].userType = apidata[0].userType;
                            temp[0].phoneNumber = apidata[0].userPhone;
                            $('#myDistInput').val(apidata[0].userName);
                            // $('#userType').val(apidata[0].userType);
                            this.setState({ SearchDispay: [], UserDataList: temp, disNameError: '', disEmailError: '', IsBroker: apidata[0].isBroker });
                        }
                    }
                    catch (error) {

                    }
                });
        }
        catch (error) {
        }
    }
    Handle_Remove_Subdistributor = () => {
        try {
            let subdislist = this.props.userLists[0].subDistributor;
            subdislist.splice(this.props.dIndex, 1);
            let SearchSubDispayl = this.props.userLists;
            this.setState({ UserDataList: SearchSubDispayl, toggleConfirmationPopup: false });
        }
        catch (error) {
        }
    }
    Handle_No_Confirmation = () => {
        this.setState({ UserDataList: this.props.userLists });
    }
    distributorvalidation(UserData) {
        this.setState({ disNameError: '', disEmailError: '', disCommissionError: '', disPhoneError: '', error: '', loading: true });
        if (UserData.userType == 'Distributor' || UserData.userType == 'Email Campaign' || UserData.userType == 'Mail Campaign' || UserData.userType == 'Broker') {
            this.setState({ disNameError: '', disEmailError: '', disCommissionError: '', disPhoneError: '' });

            let iCount = 0;

            // name validate
            if (!userService.Check_Null_Empty(UserData.distributorName)) {
                // condition to find dot
                if ((UserData.distributorName).indexOf('.') !== -1) {
                    this.setState({ disNameError: 'Dot not allowed', loading: false });
                    iCount = iCount + 1;
                } else {
                    let userNameRegex = /^\w+(\s\w+)*$/;
                    if (userNameRegex.test(UserData.distributorName)) {
                        this.setState({ disNameError: '' });
                    } else {
                        this.setState({ disNameError: 'Space not allowed', loading: false });
                        iCount = iCount + 1;
                    }
                }

            } else {
                this.setState({ disNameError: 'Name required', loading: false });
                iCount = iCount + 1;
            }

            // email validate
            if (!userService.Check_Null_Empty(UserData.emailId)) {
                if (UserData.emailId.indexOf(' ') >= 0) {
                    this.setState({ disEmailError: 'Space not allowed', loading: false });
                    iCount = iCount + 1;
                } else {

                    if (userService.ValidateEmail(UserData.emailId)) {
                        this.setState({ disEmailError: '' });
                    } else {
                        iCount = iCount + 1;
                        this.setState({ disEmailError: 'Invalid email', loading: false });
                    }
                }

            } else {
                this.setState({ disEmailError: 'Email required', loading: false });
                iCount = iCount + 1;
            }

            // commission validate
            if (!userService.Check_Null_Empty(UserData.distributorCommission)) {
                if (UserData.distributorCommission.indexOf(' ') >= 0) {
                    this.setState({ disCommissionError: 'Space not allowed', loading: false });
                    iCount = iCount + 1;
                } else {

                    if (userService.validateCurrency(UserData.distributorCommission)) {
                        this.setState({ disCommissionError: '' });
                    } else {
                        iCount = iCount + 1;
                        this.setState({ disCommissionError: 'Invalid Commission', loading: false });
                    }
                }

            } else {
                this.setState({ disCommissionError: 'Commission required', loading: false });
                iCount = iCount + 1;
            }

            // phone validate
            //if (!userService.Check_Null_Empty(UserData.phoneNumber)) {
            //    if (UserData.phoneNumber.indexOf(' ') >= 0) {
            //        this.setState({ disPhoneError: 'Space not allowed', loading: false });
            //        iCount = iCount + 1;
            //    } else {
            //        if (userService.validateNumber(UserData.phoneNumber)) {
            //            this.setState({ disPhoneError: '' });
            //        } else {
            //            iCount = iCount + 1;
            //            this.setState({ disPhoneError: 'Phone number not valid', loading: false });
            //        }
            //    }
            //}
            if (iCount == 0) {
                return true;
            }
        } else if (UserData.userType == "SMS Campaign") {
            this.setState({ disNameError: '', disEmailError: '', disCommissionError: '', disPhoneError: '' });

            let iCount = 0;

            // name validate
            if (!userService.Check_Null_Empty(UserData.distributorName)) {

                // condition to find dot
                if ((UserData.distributorName).indexOf('.') !== -1) {
                    this.setState({ disNameError: 'Dot not allowed', loading: false });
                    iCount = iCount + 1;
                } else {
                    let userNameRegex = /^\w+(\s\w+)*$/;

                    if (userNameRegex.test(UserData.distributorName)) {
                        this.setState({ disNameError: '' });
                    } else {
                        this.setState({ disNameError: 'Space not allowed', loading: false });
                        iCount = iCount + 1;
                    }
                }
            } else {
                this.setState({ disNameError: 'Name required', loading: false });
                iCount = iCount + 1;
            }

            // email validate
            if (!userService.Check_Null_Empty(UserData.emailId)) {

                if (UserData.emailId.indexOf(' ') >= 0) {
                    this.setState({ disEmailError: 'Space not allowed', loading: false });
                    iCount = iCount + 1;
                } else {

                    if (userService.ValidateEmail(UserData.emailId)) {
                        this.setState({ disEmailError: '' });
                    } else {
                        iCount = iCount + 1;
                        this.setState({ disEmailError: 'Invalid email', loading: false });
                    }
                }
            }

            // commission validate
            if (!userService.Check_Null_Empty(UserData.distributorCommission)) {

                if (UserData.distributorCommission.indexOf(' ') >= 0) {
                    this.setState({ disCommissionError: 'Space not allowed', loading: false });
                    iCount = iCount + 1;
                } else {

                    if (userService.validateCurrency(UserData.distributorCommission)) {
                        this.setState({ disCommissionError: '' });
                    } else {
                        iCount = iCount + 1;
                        this.setState({ disCommissionError: 'Invalid Commission', loading: false });
                    }
                }

            } else {
                this.setState({ disCommissionError: 'Commission required', loading: false });
                iCount = iCount + 1;
            }

            // phone validate
            //if (!userService.Check_Null_Empty(UserData.phoneNumber)) {

            //    if (UserData.phoneNumber.indexOf(' ') >= 0) {
            //        this.setState({ disPhoneError: 'Space not allowed', loading: false });
            //        iCount = iCount + 1;
            //    } else {

            //        if (userService.validateNumber(UserData.phoneNumber)) {
            //            this.setState({ disPhoneError: '' });
            //        } else {
            //            iCount = iCount + 1;
            //            this.setState({ disPhoneError: 'Phone number not valid', loading: false });
            //        }
            //    }
            //} else {
            //    iCount = iCount + 1;
            //    this.setState({ disPhoneError: 'Phone number required', loading: false });
            //}
            if (iCount == 0) {
                return true;
            }
        }
        else {
            let iCount = 0;

            // name validate
            if (!userService.Check_Null_Empty(UserData.distributorName)) {

                // condition to find dot
                if ((UserData.distributorName).indexOf('.') !== -1) {
                    this.setState({ disNameError: 'Dot not allowed', loading: false });
                    iCount = iCount + 1;
                } else {
                    let userNameRegex = /^\w+(\s\w+)*$/;

                    if (userNameRegex.test(UserData.distributorName)) {
                        this.setState({ disNameError: '' });
                    } else {
                        this.setState({ disNameError: 'Space not allowed', loading: false });
                        iCount = iCount + 1;
                    }
                }
            } else {
                this.setState({ disNameError: 'Name required', loading: false });
                iCount = iCount + 1;
            }

            // email validate
            if (!userService.Check_Null_Empty(UserData.emailId)) {
                if (UserData.emailId.indexOf(' ') >= 0) {
                    this.setState({ disEmailError: 'Space not allowed', loading: false });
                    iCount = iCount + 1;
                } else {

                    if (userService.ValidateEmail(UserData.emailId)) {
                        this.setState({ disEmailError: '' });
                    } else {
                        iCount = iCount + 1;
                        this.setState({ disEmailError: 'Invalid email', loading: false });
                    }
                }
            }

            // phone validate
            //if (!userService.Check_Null_Empty(UserData.phoneNumber)) {
            //    if (UserData.phoneNumber.indexOf(' ') >= 0) {
            //        this.setState({ disPhoneError: 'Space not allowed', loading: false });
            //        iCount = iCount + 1;
            //    } else {
            //        if (userService.validateNumber(UserData.phoneNumber)) {
            //            this.setState({ disPhoneError: '' });
            //        } else {
            //            this.setState({ disPhoneError: 'Phone number not valid', loading: false });
            //            iCount = iCount + 1;
            //        }
            //    }
            //}

            // commission validate
            if (!userService.Check_Null_Empty(UserData.distributorCommission)) {

                if (UserData.distributorCommission.indexOf(' ') >= 0) {
                    this.setState({ disCommissionError: 'Space not allowed', loading: false });
                    iCount = iCount + 1;
                } else {

                    if (userService.validateCurrency(UserData.distributorCommission)) {
                        this.setState({ disCommissionError: '' });
                    } else {
                        iCount = iCount + 1;
                        this.setState({ disCommissionError: 'Invalid Commission', loading: false });
                    }
                }

            } else {
                this.setState({ disCommissionError: 'Commission required', loading: false });
                iCount = iCount + 1;
            }
            if (iCount == 0) {
                return true;
            }
        }
    }
    isSubdistributorineditedmode() {
        let status = false;
        this.state.UserDataList[0].subDistributor.forEach(function (a) {
            if (a.isineditedmode)
                status = true;

        });
        return status;
    }
    CheckCommissionExceed() {
        let usercomm = 0;
        usercomm += parseFloat(this.state.UserDataList[0].distributorCommission);
        this.state.UserDataList[0].subDistributor.forEach(function (a) {
            usercomm += parseFloat(a.subDistributorCommission);
        });
        if (usercomm <= parseFloat(this.props.MaxComm) || this.state.UserDataList[0].IsRuleType)
            return true;
        else
            return false;
    }
    userjsondatavalidation(UserData) {
        let status = false;
        try {
            let jsondata = UserData;
            if (jsondata["subDistributor"].length > 1) {
                var subarr = jsondata["subDistributor"];
                var clean = subarr.filter((subarr, index, self) =>
                    index === self.findIndex((t) => (t.subDistributorEmail === subarr.subDistributorEmail || t.subDistributorName === subarr.subDistributorName)))
                if (jsondata["subDistributor"].length != clean.length)
                    status = false;
                else
                    status = true;
            }
            else
                status = true;
        } catch (e) {

        }
        return status;
    }
    handleSaveSubmit = (e) => {
        if (this.distributorvalidation(this.state.UserDataList[0])) {
            if (!this.isSubdistributorineditedmode())
                if (this.CheckCommissionExceed())
                    if (this.userjsondatavalidation(this.state.UserDataList[0]))
                        if (this.state.UserDataList[0].userType != "IBO/Marketplace") {
                            this.ProcessUserSubmitData(JSON.stringify(this.state.UserDataList), this.state.userdata.wholesaler_Id.toString(), this.props.SelectedGroupNumber, this.props.MaxComm);
                        }
                        else {
                            this.Process_IBOMarketPlace_Data(JSON.stringify(this.state.UserDataList), this.state.userdata.wholesaler_Id.toString(), this.props.SelectedGroupNumber, this.props.MaxComm);
                        }
                    else
                        this.setState({ error: 'Duplicate overrides not allowed', loading: false });
                else
                    this.setState({ error: 'The total commission for this group number exceeds the maximum allowed commission', loading: false });
            else
                this.setState({ error: 'Please save each override before saving changes', loading: false });
        }
    }
    ProcessUserSubmitData(UserJson, WhName, GroupNumber, MaxComm) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UserJson, WhName, GroupNumber, MaxComm })
        };
        return fetch(`/api/ws/ProcessUser`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        if (apidata[0].code == "1") {
                            this.setState({ loading: false, error: apidata[0].message });
                            $('.save-btn').attr('disabled', true);
                            if (this.state.newUser == "true" && this.state.UserDataList[0].userType == "Broker") {
                                this.setState({ advanceSetting: true });
                            }
                        }
                        else {
                            this.setState({ loading: false, error: apidata[0].message });
                        }
                    }
                    else {
                        this.setState({ loading: false, error: 'Whoops, something went wrong. Please try again' });
                    }
                }
                catch (error) {
                    this.setState({ loading: false, error: 'Whoops, something went wrong. Please try again' });
                }
            });
    }
    Process_IBOMarketPlace_Data(UserJson, WhName, GroupNumber, MaxComm) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UserJson, WhName, GroupNumber, MaxComm })
        };
        return fetch(`/api/ws/ProcessIBO`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        if (apidata[0].code == "1") {
                            this.setState({ loading: false, error: apidata[0].message });
                            $('.save-btn').attr('disabled', true);
                            if (this.state.newUser == "true" && this.state.UserDataList[0].userType == "Broker") {
                                this.setState({ advanceSetting: true });
                            }
                        }
                        else {
                            this.setState({ loading: false, error: apidata[0].message });
                        }
                    }
                    else {
                        this.setState({ loading: false, error: 'Whoops, something went wrong. Please try again' });
                    }
                }
                catch (error) {
                    this.setState({ loading: false, error: 'Whoops, something went wrong. Please try again' });
                }
            });
    }
    HandleSearchSubFocus = e => {
        let currentInput = e.target;
        if ($(currentInput).val().length == 0) {
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    handleBack = () => {
        this.props.closeEditGroupPopup();
        this.props.openManageGroup(this.props.SelectedGroupNumber, this.props.MaxComm, this.props.cPagin, this.props.cSearch, '', '', this.props.reopenFlag, this.props.allData);
    }
    confirmYes = () => {
        this.props.closeEditGroupPopup();
        this.props.openBrokerSignature(this.props.SelectedGroupNumber, this.state.UserDataList[0].distributorName, this.state.UserDataList);
    }
    confirmNo = () => {
        this.setState({ advanceSetting: false });
    }
    render() {
        const { loading, error, disNameError, disEmailError, disPhoneError, disCommissionError, WhAdvanceSetting } = this.state;
        let IsDisabled = true;
        try { IsDisabled = this.state.userdata.paramsname.toLowerCase() == 'patient rx discount' ? true : false; }
        catch (error) { }
        return (
            <div className='popup override-content'>
                <div className='popup_inner manage-distributor-design wh-edit-group'>
                    <h1>{this.props.text}<button onClick={this.handleBack}>X</button></h1>
                    <form name="form" id="mainForm" onSubmit={this.handleSubmit} className="referralPopup">

                        {this.state.UserDataList.length == 0 ? null :
                            <div>
                                <div className="field-data">
                                    <formgroup>
                                        <div className="col-lg-4">
                                            <label>Name: </label>
                                            <div className="searchSection distributor-search">
                                                <form autoComplete="off">
                                                    <div className="autocomplete">
                                                        <input type="text" id="myDistInput" className="form-control disinput" data-type="distributorName" onChange={this.handleChange} value={this.state.UserDataList[0].distributorName} defaultValue={this.state.UserDataList[0].distributorName} onKeyUp={this.HandleSearchKeyUp} />
                                                        <input type="hidden" className="form-control disinput" name="disid" value={this.state.UserDataList[0].disId} />
                                                        {
                                                            this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                                                <div id="myInputautocomplete-list" className="autocomplete-items">
                                                                    {
                                                                        this.state.SearchDispay.map((item, index) => {
                                                                            return (
                                                                                <span data-text={item.userName} onClick={this.HandleSearchItemClick}>{item.userName}</span>
                                                                            )
                                                                        })}
                                                                </div> : null : null

                                                        }
                                                        {
                                                            disNameError &&
                                                            <div className={'alert alert-danger m-group'}>{disNameError}</div>
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 gap">
                                            <label>Email: </label>
                                            {
                                                this.state.UserDataList[0].emailId != "" && this.state.UserDataList[0].emailId != null && this.state.IsUserAvail ?
                                                    <input onChange={this.handleChange} type="text" className="form-control disinput" readOnly data-type="emailId" value={this.state.UserDataList[0].emailId} /> :
                                                    <input onChange={this.handleChange} type="text" className="form-control disinput" data-type="emailId" value={this.state.UserDataList[0].emailId} />
                                            }
                                            {
                                                disEmailError &&
                                                <div className={'alert alert-danger m-group'}>{disEmailError}</div>
                                            }
                                        </div>
                                        <div className="col-lg-4">
                                            <label>Phone Number: </label>
                                            <input type="text" name="phone" className="form-control disinput" data-type="phoneNumber" onChange={this.handleChange} value={this.state.UserDataList[0].phoneNumber} />
                                            {
                                                disPhoneError &&
                                                <div className={'alert alert-danger m-group'}>{disPhoneError}</div>
                                            }
                                        </div>
                                    </formgroup>
                                    <formgroup>
                                        <div className="col-lg-4">
                                            <label>Commission ($): </label>
                                            <input type="text" className="form-control disinput" name="commission" data-type="distributorCommission" onChange={this.handleChange} value={this.state.UserDataList[0].distributorCommission} />
                                            {
                                                disCommissionError &&
                                                <div className={'alert alert-danger m-group'}>{disCommissionError}</div>
                                            }
                                        </div>
                                    </formgroup>
                                    {
                                        this.state.UserDataList[0].userType == "IBO/Marketplace" ? null :

                                            <div className="override-section">
                                                {

                                                    this.state.UserDataList[0].subDistributor.length > 0 ?
                                                        <div className="right">

                                                            <h2>Overrides</h2>
                                                            <a href="javascript:void('0')" className="add-new " onClick={this.addNewSubdistributor}>Add New Override</a>

                                                            <table>
                                                                <thead>
                                                                    <tr className="header Sub">
                                                                        <th className="first-one">Name</th>
                                                                        <th className="second-one">Email</th>
                                                                        <th className="third-one">Phone Number</th>
                                                                        <th className="fourth-one">Commission ($)</th>
                                                                        <th className="fifth-one">Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody id="scroll-on">
                                                                    {
                                                                        this.state.UserDataList[0].subDistributor.map((e1, index) => {
                                                                            let subdiscomm = 0;
                                                                            subdiscomm = parseFloat(e1.subDistributorCommission).toFixed(2).toString();
                                                                            return (
                                                                                e1.isineditedmode ?
                                                                                    <tr className="userDashData SubDist_GroupBox">
                                                                                        <td className="first-one">
                                                                                            <formgroup>
                                                                                                <div className="searchSection distributor-search sub">
                                                                                                    <form autoComplete="off">
                                                                                                        <div className="autocomplete" key={e1.subDisId}>
                                                                                                            <input type="text" textindex={index} className="form-control subDisinput" name="subdisname" data-text="Sub distributor name is required" onChange={this.subHandleChange} defaultValue={e1.subDistributorName} onFocus={this.HandleSearchSubFocus} onKeyUp={this.HandleSearchSubKeyUp} />
                                                                                                            <input type="hidden" className="form-control subDisinput" name="subdisid" value={e1.subDisId} />
                                                                                                            {
                                                                                                                this.state.SearchSubDispay[index] != null && this.state.SearchSubDispay[index].length > 0 ?

                                                                                                                    <div id="myInputautocomplete-list" className="autocomplete-items">
                                                                                                                        {
                                                                                                                            this.state.SearchSubDispay[index].map((item, i1) => {

                                                                                                                                return (
                                                                                                                                    <span key={i1} data-option={i1} data-index={index} data-text={item.userName} onClick={this.SubSearchItemClick}>{item.userName}</span>
                                                                                                                                )
                                                                                                                            })
                                                                                                                        }
                                                                                                                    </div> : null

                                                                                                            }
                                                                                                        </div>
                                                                                                    </form>
                                                                                                </div>

                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="second-one">
                                                                                            <formgroup key={e1.subDistributorEmail}>
                                                                                                <input type="text" className="form-control subDisinput" name="email" defaultValue={e1.subDistributorEmail} data-text="Email is required" onChange={this.subHandleChange} />
                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="third-one">
                                                                                            <formgroup key={e1.subDistributorPhone}>
                                                                                                <input type="text" className="form-control subDisinput" name="phone" defaultValue={e1.subDistributorPhone} onChange={this.subHandleChange} />
                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="fourth-one">
                                                                                            <formgroup key={subdiscomm}>
                                                                                                <input type="text" className="form-control subDisinput" defaultValue={subdiscomm} data-text="Comission is required" name="subcomm" onChange={this.subHandleChange} />
                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="fifth-one">
                                                                                            {!(this.validation(e1.subDistributorName, e1.subDistributorEmail, e1.subDistributorPhone, e1.subDistributorCommission)) ?
                                                                                                <input data-text={index} onClick={this.handleAdd} type="button" className="btn" value="Save" /> : <input onClick={this.handleAdd} type="button" className="btn" value="save" />
                                                                                            }
                                                                                            <input data-text={index} onClick={this.handleCancel.bind(this)} type="button" className="btn cancel" value="Cancel" />
                                                                                        </td>
                                                                                    </tr> :
                                                                                    <tr className="userDashData SubDist_GroupBox">

                                                                                        <td className="first-one">
                                                                                            <formgroup>
                                                                                                <label>{e1.subDistributorName}</label>

                                                                                                <input type="hidden" className="form-control subDisinput" name="subdisid" value={e1.subDisId} />
                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="second-one">
                                                                                            <formgroup>
                                                                                                <label>{e1.subDistributorEmail}</label>

                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="third-one">
                                                                                            <formgroup>
                                                                                                <label>{e1.subDistributorPhone}</label>
                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="fourth-one">
                                                                                            <formgroup>
                                                                                                <label>{subdiscomm}</label>
                                                                                            </formgroup>
                                                                                        </td>
                                                                                        <td className="fifth-one">
                                                                                            <a href="javascript:void('0')" data-text={index} onClick={this.handleEdit.bind(this)} className="edit custom-tooltip"><img src={EditIcon} className="editIcon" alt="editIcon" /><span className="hover-tooltip">Edit</span></a>
                                                                                            <a href="javascript:void('0')" data-text={index} onClick={this.toggleConfirmationPopup} className="delete custom-tooltip"><img src={DeleteIcon} className="deleteIcon" alt="deleteIcon" /><span className="hover-tooltip">Delete</span></a>

                                                                                        </td>
                                                                                    </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>


                                                        </div> :
                                                        <div className="right">

                                                            <h2>Overrides</h2>
                                                            <span className="no-override">No Overrides added yet</span>
                                                            <a href="javascript:void('0')" className="add-new some" onClick={this.addNewSubdistributor}>Add New Override</a>


                                                        </div>}
                                            </div>
                                    }
                                </div>
                            </div>
                        }
                        <div className="button-section manage-btn-section bottom-gap">
                            <input type="button" className={loading ? 'btn animated-btn save-btn' : 'btn save-btn'} onClick={this.handleSaveSubmit} value="Save & Submit" disabled={IsDisabled} />
                            <input type="button" onClick={this.handleBack} className="btn cancel" value="Cancel" />
                            {loading &&
                                <div className="theme-loader"></div>
                            }
                            {error &&
                                <div className={'alert alert-danger m-group'}>{error}</div>
                            }
                            {/*{
                                this.state.advanceSetting ?
                                    <div className={'advance-setting alert-danger m-group'}>Do you want to set broker signature details? &nbsp;<a href="javascript:void('0')" onClick={this.confirmYes}>Yes</a> : <a href="javascript:void('0')" onClick={this.confirmNo}>No</a></div> : null
                            }*/}


                        </div>

                    </form>

                </div>
            </div >

        );
    }
}
export default OverridePopup;